<script setup>
import useAppStore from './service/app/AppService';
import { useStorage, usePreferredDark } from '@vueuse/core';
import UserStore from '@/service/auth/UserService';
import MaintenanceOverlay from '@/components/MaintenanceOverlay.vue';

//check if the domain is portal.affimedia.nl
if (window.location.hostname == 'portal.affimedia.nl') {
    //get the full url
    const url = window.location.href;
    //new domain
    const newDomain = 'https://legalclaimassistant.support';
    //replace the domain only and keep the rest of the URL
    window.location = url.replace(window.location.origin, newDomain);
}

const appSettings = useAppStore();

const localStorage = useStorage('theme_preference');

const userTimezone = useStorage('report_timezone');

// const UserService = UserStore();

if (!userTimezone.value) {
    userTimezone.value = 'America/New_York';
}
// if (UserService.isLoggedIn) {
UserStore().setUserDataIfloggedIn();
// }

appSettings.setTheme(localStorage.value ?? (usePreferredDark() ? 'dark' : 'light'));
</script>

<template>
    <router-view />
    <Toast />
    <MaintenanceOverlay />
</template>

<style scoped></style>
